// (function () {
//     'use strict';

//     angular.module("imApp").factory("p2UpdateProcedureEditService", ['$ihttp', function ($ihttp) {
//         let service = {
//             getUpdateProcedure: function (parms) {
//                 return $ihttp.post({
//                     method: 208,
//                     parameters: parms || {}
//                 });
//             },
//             saveObj: function (edit) {
//                 return $ihttp.post({
//                     method: 209,
//                     parameters: edit
//                 });
//             }
//         };

//         return service;
//     }]);
// })();
